import { APP_INITIALIZER, makeEnvironmentProviders } from '@angular/core';
import { TranslateLoader, TranslateCompiler, MissingTranslationHandler } from '@ngx-translate/core';
import { TranslateMessageFormatCompiler } from 'ngx-translate-messageformat-compiler';

import { I18N_CONFIG, I18nConfig } from './tokens/i18n-config.token';
import { CustomTranslateLoader } from './loader/translate.loader';
import { MyMissingTranslationHandler } from './handlers/missing-translation.handler';
import { LanguageStateService } from './services/language-state.service';
import { StorageService } from './services/storage.service';
import { LocalStorageService } from './services/storage-web.service';
import { LanguageFacade } from './facade';
import { LanguageInitService } from './services/language-init.service';

export function initApp(
  lang: LanguageFacade,
  init: LanguageInitService
) {
  return () => {
    init.init();        // defineLocale FIRST
    return lang.initApp(); // THEN setLanguage
  };
}

export function provideI18n(config: I18nConfig) {
  return makeEnvironmentProviders([
    { provide: I18N_CONFIG, useValue: config },
    LanguageStateService,
    { provide: StorageService, useClass: LocalStorageService },
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [LanguageFacade, LanguageInitService],
      multi: true,
    },
    {
      provide: TranslateLoader,
      useClass: CustomTranslateLoader,
    },
    {
      provide: TranslateCompiler,
      useClass: TranslateMessageFormatCompiler,
    },
    {
      provide: MissingTranslationHandler,
      useClass: MyMissingTranslationHandler,
    },
  ]);
}